















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import ChartRawFootProgression from '@/components/charts/walking/ChartRawFootProgression.vue';
import { get } from 'lodash';

@Component({
  components: { ChartRawFootProgression },
})
export default class PatientAcquisitionExportationFrameWalkingContainerChartRawFootProgression extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  get canDisplayProgressionAngle() {
    return !!get(this.acquisition!.computed_data, 'left.aggregates.foot_progression_angle_FF', null);
  }
}
